import object from "actions/helper/object";

const getRightClass = cl => {
    return cl ? (cl.toLowerCase ? cl.split(" ") : cl) : [];
};

const obj = {
    addClass(node, cl) {
        node.classList.add(...getRightClass(cl));
    },

    removeClass(node, cl) {
        node && node.classList && node.classList.remove(...getRightClass(cl));
    },

    hasClass(node, cl) {
        return node.classList.contains(cl);
    },

    toggleClass(node, cl) {
        if (node.classList.contains(cl)) {
            this.removeClass(node, cl);
        } else {
            this.addClass(node, cl);
        }
    },

    addRemoveClass(node, cl, flag) {
        if (flag)
            this.addClass(node, cl);
        else
            this.removeClass(node, cl);
    },

    isChildOf(node, parent) {
        if (!node || !parent)
            return null;

        if (node === parent)
            return true;

        let flag = false;
        node = node.parentNode;
        while (node) {
            if (node === parent) {
                flag = true;
                break;
            }

            node = node.parentNode;
        }

        return flag;
    },

    coords(node) {
        const c = node.getBoundingClientRect();

        return {
            l: node.offsetLeft,
            t: node.offsetTop,
            x: c.left,
            y: c.top,
            w: node.offsetWidth,
            h: node.offsetHeight,
            wVis: c.right - c.left,
            hVis: c.bottom - c.top
        };
    },

    display(node, flag) {
        this.style(node, "display", flag ? "" : "none");
    },

    style(node, prop, value) {
        const l = arguments.length;
        const s = window.getComputedStyle(node, null);

        if (l === 1)
            return s;

        if (l === 2) {
            if (prop?.toLowerCase)
                return s[prop] || node.style[prop];

            if (object.isObject(prop)) {
                Object.keys(prop).forEach(key => {
                    node.style[key] = prop[key];
                });
            }
        } else
            node.style[prop] = value;
    },

    styleProp(node, prop, value) {
        const t = "--";
        const isS = prop?.toLowerCase;
        const p = isS ? (t + prop) : prop;

        if (arguments.length === 2) {
            if (isS)
                return node.style.getPropertyValue(p);
            else if (object.isObject(prop)) {
                Object.keys(prop).forEach(key => {
                    node.style.setProperty(t + key, prop[key]);
                });
            }
        } else
            node.style.setProperty(p, value);
    },

    getParentByClass(node, cl) {
        if (!node || this.hasClass(node, cl))
            return node;

        while (node.parentNode) {
            if (this.hasClass(node, cl))
                return node;

            node = node.parentNode;
        }

        return null;
    },

    clone(nodeOrig, parent) {
        const node = document.importNode(nodeOrig, true);
        (parent || nodeOrig.parentNode).appendChild(node);

        return node;
    },

    query(node, cl, all = false) {
        return (node || document)[all ? "querySelectorAll" : "querySelector"](cl);
    },

    getChildIndex(node) {
        let i = 0;
        node = node.previousElementSibling;
        while (node) {
            i++;
            node = node.previousElementSibling;
        }
        return i;
    },

    placeBefore(node, ref) {
        const parent = ref?.parentNode;

        if (parent)
            parent.insertBefore(node, ref);
    },

    placeAfter(node, ref) {
        const parent = ref?.parentNode;

        if (parent) {
            if (parent.lastChild === ref)
                parent.appendChild(node);
            else
                parent.insertBefore(node, ref.nextSibling);
        }
    },

    place(node, refNode, position) {
        if (!refNode)
            refNode = node.parentNode;

        if (position?.toFixed) {
            if (position < 1)
                position = "first";
            else {
                if (this.isChildOf(node, refNode)) {
                    const nodePos = this.getChildIndex(node);

                    if (nodePos < position)
                        position++;
                }

                if (refNode.childNodes[position]) {
                    refNode = refNode.childNodes[position];
                    position = "before";
                }
                else
                    position = "";
            }
        }

        if (!position)
            refNode.appendChild(node);
        else if (position === "before")
            this.placeBefore(node, refNode);
        else if (position === "after")
            this.placeAfter(node, refNode);
        else if (position === "first") {
            if (refNode.firstChild)
                this.placeBefore(node, refNode.firstChild);
            else
                refNode.appendChild(node);
        }
    }
};

export default obj;
